import axios from 'axios'

// 
export default {
    login(params){
        return axios({
            method: "get",
            url: "/login",
            params: params
        })
    },
    // anonymous 用户登录 获取token
    anonymousLogin(params){
        return axios({
            method: "get",
            url: "/user/login",
            params: {
                name: "anonymous",
                password: "123456",
            }
        })
    },
    getToken(){
        return axios({
            method: "get",
            url: "/user/getToken",
        })
    },
}